import { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { Box, InputBase } from '@mui/material';
import { styled, alpha, useTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

import SearchModal from './search-modal';

const StyledInputBase = styled(InputBase)(({ theme }: { theme: Theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    cursor: 'pointer',
  },
})) as typeof InputBase;

export default function SearchBar() {
  const theme = useTheme();

  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          borderRadius: theme.shape.borderRadius,
          backgroundColor: alpha(theme.palette.common.white, 0.15),
          '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
          },
          ml: 0,
          [theme.breakpoints.up('sm')]: {
            ml: theme.spacing(1),
            width: 'auto',
          },
        }}>
        <Box
          sx={{
            p: theme.spacing(0, 2),
            height: '100%',
            position: 'absolute',
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <SearchIcon />
        </Box>
        <StyledInputBase
          readOnly
          placeholder="Search…"
          inputProps={{ 'aria-label': 'search' }}
          onClick={() => setIsSearchModalOpen(true)}
        />
      </Box>
      <SearchModal open={isSearchModalOpen} handleClose={() => setIsSearchModalOpen(false)} />
    </>
  );
}
